<template>
  <div id="login">
    <div class="login__bg"><img src="https://index.cuican520.com/xm-bg.png" alt=""></div>
    <!-- <div class="login__bg"><img src="https://index.cuican520.com/bg2.png" alt=""></div> -->
    <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px" class="demo-ruleForm login-container">
      <!-- <h3 class="title"><i class="cuicanLogo"></i><span>琅粤后台管理</span></h3> -->
      <el-form-item prop="account">
        <el-input type="text" v-model="ruleForm2.account" auto-complete="off" placeholder="账号" class="inputstyls">
          <template slot="prepend">
            <img src="../../public/user.png" alt="">
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="checkPass">
        <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off" placeholder="密码" class="inputstyls">
          <template slot="prepend">
            <img src="../../public/pwd.png" alt="">
          </template>
        </el-input>
      </el-form-item>
      <!-- <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox> -->
      <el-form-item style="width:100%;">
        <!-- <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit2" :loading="logining">登录</el-button> -->
        <el-button type="primary btnstyls" style="width:100% !important;" @click.native.prevent="handleSubmit2" @keyup.enter="handleSubmit2">登录</el-button>
      </el-form-item>
    </el-form>
   <div class="myfoot">copyright @2020-2023 三门峡铜沐电子科技有限公司 版权所有</div>
   <!-- <div class="myfoot">copyright @2018-2019 博速（上海）企业管理有限公司 版权所有</div> -->
  </div>
</template>
<script>
import { requestLogin } from '../api'
import qs from 'qs'
export default {
  name: 'login',
  data () {
    return {
      logining: false,
      ruleForm2: {
        account: '',
        checkPass: ''
      },
      rules2: {
        account: [
          {
            required: true,
            message: '请输入账号',
            trigger: 'blur'
          }
        ],
        checkPass: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      checked: true
    }
  },
  methods: {
    // handleReset2 () {
    //   this.$refs.ruleForm2.resetFields()
    // },
    handleSubmit2 () {
      this.logining = true  
      var loginParams = qs.stringify({ 'loginName': this.ruleForm2.account, 'pwd': this.ruleForm2.checkPass })
      console.log(loginParams)
      requestLogin(loginParams).then(data => {
        console.log(data)
        this.logining = false
        let { code } = data
        if (code !== 10000) {
          this.$message({
            message: '用户名或者密码错误',
            type: 'error'
          })
        } else {
          sessionStorage.setItem('user', data.data.name)
          sessionStorage.setItem('roleCode', data.data.roleCode)
          this.$router.push({ path: '/kclist', query: { name: data }})
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
#login 
    .login__bg
      img
        width 100%
    .el-input-group__append, .el-input-group__prepend
    border-right none
    img
      width 16px
    input
      border-left none
    .el-input::-webkit-scrollbar-thumb
      background-color #fff
    // .btnstyls
    //   background-color #032e46
    //   border-color #032e46
    .btnstyls
      background-color #1f1f1f
      border-color #1f1f1f
.login-container {
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin 0 auto 
    margin-top 100px
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    height 280px
  }
.el-form-item
  margin-bottom 40px
.myfoot
    width: 100%;
    // position absolute
    bottom 20px
    text-align center
    padding-bottom 0
</style>